export default "__VITE_ASSET__c45e0080__"